import { useQuery, useMutation } from "@tanstack/react-query";
import clientPortalAxiosInstance from "../../common/utilities/axios/clientPortalAxiosInstance";

/**Queries */
export const useGetProgrammeDescriptorByIdQuery = ({ programDescriptorId }) => {
  return useQuery({
    queryKey: ["getProgrammeDescriptorByIdQuery", `${programDescriptorId}`],
    queryFn: () => {
      return clientPortalAxiosInstance
        .get(
          `/Reports-Resources/report/getProgramDescriptorsById/${programDescriptorId}`
        )
        .then((res) => {
          return res.data;
        });
    },
    enabled: !!programDescriptorId,
  });
};

/**Mutations */
export const useViewProgrammeDescriptorListMutation = () => {
  return useMutation({
    mutationFn: ({ loggedInUserId, roleId, isEnterpriseAdmin }) => {
      return clientPortalAxiosInstance.post(
        `/Reports-Resources/report/roleBasedGetAllProgramDescriptors`,
        {
          LoggedInUserId: loggedInUserId || "",
          RoleId: roleId || "",
          IsEnterpriseAdmin: isEnterpriseAdmin,
        }
      );
    },
  });
};

export const useCreateProgramDescriptorMutation = () => {
  return useMutation({
    mutationFn: ({ body }) => {
      return clientPortalAxiosInstance.post(
        `/Reports-Resources/report/createProgramDescriptor`,
        body
      );
    },
  });
};

export const useGetProgramDescriptorOwnersQuery = () => {
  return useQuery({
    queryKey: ["getProgramDescriptorOwnersQuery"],
    queryFn: () => {
      return clientPortalAxiosInstance
        .get(`/Reports-Resources/reportsresources/programdescriptor/owners`)
        .then((res) => {
          return res.data;
        });
    },
  });
};

export const useUpdateProgramDescriptorMutation = () => {
  return useMutation({
    mutationFn: ({ body, programDescriptorId }) => {
      return clientPortalAxiosInstance.put(
        `/Reports-Resources/report/updateProgramDescriptor/${programDescriptorId}`,
        body
      );
    },
  });
};

export const useDeleteProgramDescriptorMutation = () => {
  return useMutation({
    mutationFn: ({ isDeleteMode, programDescriptorId }) => {
      return clientPortalAxiosInstance.delete(
        `/Reports-Resources/report/deleteProgramDescriptor/${programDescriptorId}`,
        {
          data: {
            IsDeleteMode: isDeleteMode,
          },
        }
      );
    },
  });
};

export const useGetAllClientForPDMutation = () => {
  return useMutation({
    mutationFn: ({ reportResourceId }) => {
      return clientPortalAxiosInstance.get(
        `/Reports-Resources/report/getAllClientForPD/${reportResourceId}`
      );
    },
  });
};

export const useUploadProgramDescriptorFileMutation = () => {
  return useMutation({
    mutationFn: ({ file }) => {
      const formData = new FormData();
      formData.append("file", file);
      return clientPortalAxiosInstance.post(
        `/Reports-Resources/report/uploadProgramDescriptorDocument`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    },
  });
};
